<template>
	<div>
		<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>
	</div>
</template>

<script>
	import TestResult from "@/models/testResult.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"

	export default {
		components: {
			EntityCard,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.resultId,
					articleId: this.$route.params.id,
				},
				schema: TestResult.getCreateSchema(),
				showModal: false,
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await TestResult.create(entity);
				this.$router.replace(`/artigos/${this.entity.articleId}/resultado/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				const response = await TestResult.getInfo(entityId);
				return response;
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return TestResult.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await TestResult.remove(entityId);
				this.$router.push("/artigos");
			},
		},
	};
</script>

<style>
.tab-pane-1,
.tab-pane-2 {
  width: 100% !important;
}

.modal-container {
	box-shadow: none !important;
}
</style>